var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
/**
 * MARC subfield that is auto-composed from editable components.
 * The subfield value is read-only (computed) and sits in the input column of its own row,
 * `$code | label | value`, like every other subfield (CZNA-1376). The editable components
 * follow, one `ComponentRow` each.
 */
import React from 'react';
import { useIntl } from 'react-intl';
import { subfieldRowStyle, subfieldCodeStyle, subfieldLabelStyle, subfieldActionsStyle, subfieldReadOnlyInputStyle, } from './subfieldStyles';
var autoTagStyle = {
    fontSize: '11px',
    fontWeight: 400,
    color: '#999',
    fontStyle: 'italic',
    marginLeft: '4px',
};
/** Shaped like a disabled subfield input, so the value box lines up with the inputs below. */
var readOnlyStyle = __assign(__assign({}, subfieldReadOnlyInputStyle), { minWidth: 0, color: '#333', fontStyle: 'italic' });
var emptyValueStyle = {
    color: '#bbb',
};
var SubfieldWithComponents = function (_a) {
    var code = _a.code, label = _a.label, value = _a.value, required = _a.required, emptyPlaceholder = _a.emptyPlaceholder, children = _a.children;
    var intl = useIntl();
    // NB: distinct from the badge below (CZNA-463) — the badge always announces
    // that the value is computed, while this placeholder explains why the
    // read-only box is empty right now. Using the same string for both produced
    // a visible/audible duplicate ("(automaticky generováno) automaticky generováno").
    var placeholder = emptyPlaceholder
        || intl.formatMessage({ id: 'ui-czna-authorities.proposalForm.autoGeneratedEmpty' });
    return (React.createElement("div", null,
        React.createElement("div", { style: subfieldRowStyle },
            React.createElement("span", { style: subfieldCodeStyle },
                "$",
                code),
            React.createElement("span", { style: subfieldLabelStyle },
                label,
                required && React.createElement("span", { style: { color: '#d0021b', marginLeft: '2px' } }, "*"),
                React.createElement("span", { style: autoTagStyle },
                    ' ',
                    "(",
                    intl.formatMessage({ id: 'ui-czna-authorities.proposalForm.autoGenerated' }),
                    ")")),
            React.createElement("div", { style: readOnlyStyle, "data-computed-value": code }, value || React.createElement("span", { style: emptyValueStyle }, placeholder)),
            React.createElement("span", { style: subfieldActionsStyle, "aria-hidden": "true" })),
        children));
};
export default SubfieldWithComponents;
